import { defineMessages } from 'react-intl-next';

export const i18n: {
	searchButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rootSpaceNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rootPageNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidPageContext: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchButtonText: {
		id: 'pagetree-search-macro.search-button-text',
		defaultMessage: 'Search',
		description: 'Label for the search submit button in the pagetree search macro.',
	},
	rootSpaceNotFound: {
		id: 'pagetree-search-macro.root-space-not-found',
		defaultMessage: 'The selected space cannot be found.',
		description:
			'Error message displayed when the space key specified in the macro parameters does not exist.',
	},
	rootPageNotFound: {
		id: 'pagetree-search-macro.root-page-not-found',
		defaultMessage: 'The selected root page could not be found.',
		description:
			'Error message displayed when the root page specified in the macro parameters cannot be found.',
	},
	invalidPageContext: {
		id: 'pagetree-search-macro.invalid-page-context',
		defaultMessage: 'The selected context is not a valid hierarchical page',
		description:
			'Error message displayed when the macro is used outside a valid page context and no root page is specified.',
	},
	error: {
		id: 'pagetree-search-macro.error',
		defaultMessage: "We're unable to display the page tree search. Refresh to try again",
		description: 'Generic error message displayed when the pagetree search macro fails to render.',
	},
});
